import React, { useState } from 'react';
import ButtonHeaderUI from '../HeaderButton';
import setting_icon from '../../icons/setting.svg';
import { Popover } from 'antd';
import ButtonSettingPopoverContent from './components/ButtonSettingPopoverContent';

const ButtonSetting = () => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    console.log('test');
    setOpen(newOpen);
  };

  return (
    <Popover
      placement='bottom'
      overlayInnerStyle={{ padding: 0 }}
      content={<ButtonSettingPopoverContent onHide={() => setOpen(false)} />}
      title={null}
      trigger='click'
      open={open}
      onOpenChange={handleOpenChange}
    >
      <ButtonHeaderUI title={'Setting'} src={setting_icon} alt={'setting_icon'} />
    </Popover>
  );
};

export default ButtonSetting;
